module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Track.c2168049.svg";